<template>
  <router-view></router-view>
</template>
<script>
import {useRoute, useRouter} from 'vue-router'
import {onMounted} from 'vue'

export default {
  setup() {
    const router = useRouter()
    const route = useRoute()
    onMounted(()=>route.path === '/' && router.replace({name: 'ScenicSpots'}))
  }
}
</script>
